import api from "@/lib/api";

export async function buildTourSteps(user) {
  const steps = [
    {
      route: "/",
      target: "client-dashboard",
      title: "Bem-vindo(a) ao Portal BAUEN!",
      text: "Vamos fazer um tour rápido pelas principais telas do portal. Você pode pular a qualquer momento.",
      placement: "center",
    },
    {
      route: "/",
      target: "kpi-active-projects",
      title: "Seu resumo",
      text: "Aqui você acompanha quantos projetos estão ativos, quantos documentos já foram enviados e quantos aguardam análise.",
      placement: "bottom",
    },
    {
      route: "/",
      target: "cronograma-widget",
      title: "Cronograma da obra",
      text: "Veja o progresso geral do cronograma e qual é a próxima etapa prevista para sua obra.",
      placement: "right",
    },
    {
      route: "/",
      target: "nav-projects",
      title: "Meus Projetos",
      text: "Clique aqui para ver todas as obras vinculadas à sua empresa.",
      placement: "right",
    },
    {
      route: "/projects",
      target: "client-projects-grid",
      title: "Lista de projetos",
      text: "Cada card é um projeto. Clique em um deles para ver documentos, status e cronograma detalhado.",
      placement: "top",
    },
  ];

  let firstProjectId = null;
  try {
    const r = await api.get("/dashboard/stats");
    firstProjectId = r.data?.my_projects?.[0]?.id || null;
  } catch (_e) { void _e; }

  if (firstProjectId) {
    steps.push(
      {
        route: `/projects/${firstProjectId}`,
        target: "main-tab-cronograma",
        title: "Cronograma",
        text: "Nesta aba você acompanha o checklist de etapas da obra e o percentual concluído.",
        placement: "bottom",
      },
      {
        route: `/projects/${firstProjectId}`,
        target: "main-tab-documentos",
        title: "Documentos",
        text: "Aqui ficam todos os documentos organizados por categoria — você pode visualizar, comentar e enviar novos arquivos.",
        placement: "bottom",
      },
    );
  }

  const lastRoute = steps[steps.length - 1].route;
  steps.push(
    {
      route: lastRoute,
      target: "nav-notifications",
      title: "Notificações",
      text: "Sempre que houver uma atualização em algum documento ou etapa, você será notificado aqui.",
      placement: "right",
    },
    {
      route: "/notifications",
      target: "notifications-page",
      title: "Central de notificações",
      text: "Todas as suas notificações ficam reunidas nesta página.",
      placement: "top",
    },
    {
      route: "/notifications",
      target: "nav-guide",
      title: "Guia de uso",
      text: "Pronto! Você pode reabrir este tutorial e ver o guia completo a qualquer momento por aqui.",
      placement: "right",
    },
  );

  if (user?.client_role === "DONO") {
    steps.push({
      route: "/notifications",
      target: "nav-client-users",
      title: "Gerenciar equipe",
      text: "Como responsável da conta, você pode cadastrar colegas, definir permissões e ativar/desativar acessos aqui.",
      placement: "right",
    });
  }

  return steps;
}
